

export const projects = [
  {
    name: "Festival Dust",
    sectionId: 'festival-dust',
    href: 'https://festivaldust.com',
    shortDescription: 'My app to plan music festivals with friends.',
    longDescription: 'An app to access all music festival lineups, set times, and schedules in one place.',
    shortTimeFrame: '2023 - Current',
    roles: ['Founder', 'Designer', 'Engineer'],
    tech: ['React', 'Flutter', 'NextJS', 'Dart', 'Firebase', 'NodeJS'],
    imgLink: '/project-icons/festival-dust.png',
    bigImgLink: '/festival-dust/main.png',
    bullets: [
      '70k+ app users. 10-25k MAU. 4.8+ star rating on both app stores',
      '10-30k+ monthly web visitors',
      '3M+ annual impressions on Google',
    ],
  },
  {
    name: "Farmshare",
    sectionId: 'farmshare',
    shortDescription: 'First engineering hire at seed stage startup.',
    longDescription: 'First engineering hire on team of 6 to help farmers sell direct to consumer',
    shortTimeFrame: '2024',
    roles: ['Designer', 'Engineer'],
    tech: ['React', 'Javascript', 'NextJS', 'NodeJS', 'GraphQL', 'Typescript'],
    imgLink: '/project-icons/farmshare.png',
    bigImgLink: '/farmshare/main.png',
    bullets: [
      'Led design for all tech built during my time there.',
      'Built scheduling SaaS platform for meat processors alongside one other engineer in <2 months.',
      'Designed and built new marketing website for company.',
    ],
  },
  // {
  //   name: "Bucket List App",
  //   shortDescription: 'Building bucket list app for a client.',
  //   shortTimeFrame: '2024 - Current',
  //   roles: ['Designer', 'Engineer'],
  //   tech: ['Flutter', 'Dart', 'Firebase'],
  //   imgLink: '/project-icons/bucket.png',
  // },
  {
    name: "Houzz",
    sectionId: 'houzz',
    shortDescription: 'SEO Team SWE.',
    shortTimeFrame: '2021 - 2022',
    roles: ['Engineer', 'SEO'],
    tech: ['React', 'Javascript', 'NodeJS', 'PHP'],
    imgLink: '/project-icons/houzz.png',
    bigImgLink: '/houzz/main.png',
    bullets: [
      'Revamped customer acquisition funnel increasing conversion by 40%',
      'Built various other pages and features on the SEO team.',
      // 'Designed and built new marketing website for company.',
    ],
  },
  {
    name: "Bison Finance",
    sectionId: 'bison',
    shortDescription: 'An automated personal finance app integrated with Plaid.',
    shortTimeFrame: '2020 - 2022',
    roles: ['Designer', 'Engineer'],
    tech: ['React', 'Javascript', 'NodeJS', 'Express', 'MongoDB'],
    imgLink: '/project-icons/bison.png',
    bigImgLink: '/bison/main.png',
    bullets: [
      'Fully automated personal finance app I built to track spending.',
      'Integrated with Plaid to automatically update with your transactions.',
      'First project I designed (so the UI admittedly needs some work.)',
    ],
  },
  {
    name: "Target",
    shortDescription: 'Rebuilt new alerting platform for Target.',
    shortTimeFrame: '2019 - 2021',
    roles: ['Engineer'],
    tech: ['React', 'Javascript', 'NodeJS', 'GoLang'],
    imgLink: '/project-icons/target.png',
  },
  {
    name: "Amazon",
    shortDescription: 'Internship long ago.',
    shortTimeFrame: '2018',
    roles: ['Engineer'],
    tech: ['Java'],
    imgLink: '/project-icons/amazon.png',
  },
];

export const cxProjects = [
  {
    name: "Red Rocks",
    sectionId: 'redrocks',
    shortDescription: 'Working food & beverage serving at Red Rocks.',
    longDescription: 'Working food & beverage serving at Red Rocks.',
    shortTimeFrame: '2024',
    roles: ['Cashier', 'Bartender'],
    tech: ['Cashiering', 'Bartending'],
    imgLink: '/project-icons/red-rocks.png',
    bigImgLink: '/red-rocks/main.png',
    bullets: [
      'Served food & beverage to thousands of concert-goers at Red Rocks.',
      '2 Seasons so far. 2024 to Current.'
    ],
  },
  {
    name: "Ridestore (Montec & DopeSnow)",
    sectionId: 'ridestore',
    shortDescription: 'Virtual customer service serving "Wow" to customers.',
    longDescription: 'Virtual customer service serving "Wow" to customers.',
    shortTimeFrame: '2024',
    roles: ['CX Ninja', 'Customer Success', 'Customer Service'],
    tech: ['CX Ninja', 'Customer Success', 'Customer Service'],
    imgLink: '/project-icons/ridestore.png',
    bigImgLink: 'ridestore/main.png',
    bullets: [
      'Helped thousands of customers find the right snowboard and ski gear as well as assist with shipping issues, product repairs, returns, and anything else!',
      'Used Intercom to handle multiple customer conversations at once.',
      '2 Seasons from 2024 to 2026.',
      'Traveled to Sweden, Great Britain, The Netherlands, Andorra, and Switzerland.',
    ],
  },
  {
    name: "Powder7",
    sectionId: 'powder7',
    shortDescription: 'Selling skis and snowboards as well as servicing winter sports equipment.',
    longDescription: 'Selling skis and snowboards as well as servicing winter sports equipment.',
    shortTimeFrame: '2024',
    roles: ['Customer Service', 'Winter Sports Sales'],
    tech: ['Customer Service', 'Winter Sports Sales'],
    imgLink: '/project-icons/powder7.png',
    bigImgLink: '',
    bullets: [
      'Helped customers in person find the right ski / snowboard for them.',
      'Very anti-sales culture in finding the right ski for the customer regardless of price.',
    ],
  },
]
